export const modules = {
  getterTempConfig(state) {
    return state.tempConfig;
  },
  getterCategory(state) {
    return state.category;
  }
};
